import axios from 'axios';
import config from '../config';

const axiosInstance = axios.create({
  baseURL: config.apiUrl,
});

let clerkSession = null;

export const setClerkSession = (session) => {
  clerkSession = session;
};

// Keep backward compat
export const setClerkTokenGetter = (getter) => {
  // ignore - using session directly now
};

axiosInstance.interceptors.request.use(
  async (requestConfig) => {
    if (clerkSession) {
      try {
        const token = await clerkSession.getToken();
        if (token) {
          requestConfig.headers.Authorization = `Bearer ${token}`;
        } else {
          console.warn('[axios] session.getToken() returned null');
        }
      } catch (err) {
        console.error('[axios] Failed to get token from session:', err);
      }
    } else {
      console.warn('[axios] No clerk session set');
    }
    return requestConfig;
  },
  (error) => Promise.reject(error)
);

export default axiosInstance;
